// تنظیمات تم و رنگ‌های قابل سفارشی‌سازی
export const themeConfig = {
  primaryColor: '#0D887E',
  secondaryColor: '#0D887E',
  successColor: '#0D887E',
  warningColor: '#faad14',
  errorColor: '#ff4d4f',
  infoColor: '#0D887E',

  light: {
    mode: 'light',
    background: '#ffffff',
    surface: '#fafafa',
    text: '#000000',
    textSecondary: '#595959',
    border: '#d9d9d9',
    headerBg: '#070B14',
    sidebarBg: '#ffffff',
    sidebarHover: 'rgba(13, 136, 126, 0.1)',
    cardBg: '#ffffff',
    shadow: 'rgba(0, 0, 0, 0.1)',
  },

  dark: {
    mode: 'dark',
    background: '#070B14',
    surface: '#070B14',
    text: '#ffffff',
    textSecondary: 'rgba(255, 255, 255, 0.65)',
    border: 'rgba(13, 136, 126, 0.22)',
    headerBg: '#070B14',
    sidebarBg: '#070B14',
    sidebarHover: 'rgba(13, 136, 126, 0.12)',
    cardBg: '#070B14',
    shadow: 'rgba(0, 0, 0, 0.35)',
  },
};

export const updateThemeColors = (colors) => {
  Object.assign(themeConfig, colors);
};
